/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { motion } from "framer-motion";

interface StyledRadioProps {
  check: boolean;
  handleCheck?: () => void;
  inverted?: boolean;
}

export function StyledRadio(props: StyledRadioProps): JSX.Element {
  const { check, handleCheck, inverted } = props;

  return (
    <motion.div
      onClick={handleCheck}
      css={css`
        cursor: pointer;
        width: 21px;
        height: 21px;
        max-width: 21px;
        max-height: 21px;
        border-radius: 50%;
        border: 1px solid ${inverted && !check ? "#707070" : "#FB972E"};
        display: flex;
        align-items: center;
        justify-content: center;
      `}
    >
      {check && (
        <motion.div
          animate={{ scale: 2 }}
          transition={{ duration: 0.1 }}
          css={css`
            width: 5px;
            height: 5px;
            border-radius: 50%;
            border: 1px solid #fb972e;
            background-color: #fb972e;
          `}
        />
      )}
    </motion.div>
  );
}
